var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _Basic = require("../../../elements/Basic");

var _Tab = _interopRequireDefault(require("./Tab"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Web/TabView/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var TabView = function (_React$Component) {
  (0, _inherits2.default)(TabView, _React$Component);

  var _super = _createSuper(TabView);

  function TabView(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TabView);
    _this = _super.call(this, props);

    _this.onPress = function (index, label) {
      var onPress = _this.props.onPress;

      if (onPress) {
        onPress(index, label);
      }

      if (_this.state.selectedIndex !== index) {
        _this.setState({
          selectedIndex: index
        });
      }
    };

    _this.renderedIndexes = [];
    _this.state = {
      selectedIndex: props.startIndex || 0
    };
    return _this;
  }

  (0, _createClass2.default)(TabView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          labels = _this$props.labels,
          children = _this$props.children,
          bigTabs = _this$props.bigTabs,
          renderTab = _this$props.renderTab,
          rowStyle = _this$props.rowStyle,
          onMobile = _this$props.onMobile,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["labels", "children", "bigTabs", "renderTab", "rowStyle", "onMobile"]);
      var selectedIndex = this.state.selectedIndex;
      if (!labels || !children) return null;
      return _react.default.createElement(_Basic.Column, (0, _extends2.default)({
        flexing: true,
        width: "100%"
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35,
          columnNumber: 13
        }
      }), _react.default.createElement(_Basic.Row, (0, _extends2.default)({
        isFlex: true,
        alignItems: "center",
        justifyContent: "center",
        borderBottom: 1,
        borderColor: "border.main",
        overflow: onMobile ? 'scroll' : 'hidden',
        iosOverflow: onMobile,
        hideScrollbar: onMobile
      }, rowStyle, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 17
        }
      }), labels.map(function (item, index) {
        return _react.default.createElement(_Basic.Column, {
          key: "tab_column_" + item,
          flexing: bigTabs,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 48,
            columnNumber: 25
          }
        }, typeof renderTab === 'function' ? renderTab({
          title: item,
          isActive: selectedIndex === index,
          bigTabs: bigTabs,
          onPress: function onPress() {
            return _this2.onPress(index, labels[index]);
          }
        }) : _react.default.createElement(_Tab.default, {
          title: item,
          onPress: function onPress() {
            return _this2.onPress(index, labels[index]);
          },
          isActive: selectedIndex === index,
          bigTab: bigTabs,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 58,
            columnNumber: 33
          }
        }));
      })), _react.default.Children.map(children, function (child, i) {
        if (i === selectedIndex && !_this2.renderedIndexes.includes(i)) _this2.renderedIndexes.push(i);
        return _react.default.createElement(_Basic.Column, {
          display: i === selectedIndex ? 'block' : 'none',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 75,
            columnNumber: 25
          }
        }, _this2.renderedIndexes.includes(i) ? child : null);
      }));
    }
  }]);
  return TabView;
}(_react.default.Component);

var _default = TabView;
exports.default = _default;